export default __webpack_public_path__ + "static/media/surveyJS.a19eb91e.md";